import {
    JUMIO_HAVE_COPY_ID_FAX_VALUE,
    JUMIO_VERIFICATION_STATUS
} from '../constants';

export const useVerificationStatus = ({ uploadRequirement, haveCopyIDFax }) => {
    if (haveCopyIDFax === JUMIO_HAVE_COPY_ID_FAX_VALUE.VERIFIED) {
        return JUMIO_VERIFICATION_STATUS.VERIFIED;
    }

    if (uploadRequirement === JUMIO_VERIFICATION_STATUS.PENDING) {
        return JUMIO_VERIFICATION_STATUS.PENDING;
    }

    return JUMIO_VERIFICATION_STATUS.NOT_VERIFIED;
};
